import { useState } from "react";
import classes from "./LabResult.module.css";

import {
    FaFlask,
    FaTimes,
    FaPrint,
    FaDownload,
    FaPaperPlane,
    FaUserFriends,
} from "react-icons/fa";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    ReferenceLine,
} from "recharts";

function LabResult({ test, onClose }) {
    const [comment, setComment] = useState("");
    const [activeTab, setActiveTab] = useState("Test Result");
    const handlePrint = () => {
        window.print();
    };
    const handleDownload = () => {
        window.print();
    };
    const graphData = [
        { date: "Jan", value: 12.8 },
        { date: "Feb", value: 13.1 },
        { date: "Mar", value: 13.4 },
        { date: "Apr", value: 13.2 },
        { date: "May", value: 13.8 },
        { date: "Jun", value: 13.6 },
    ];
    const resultData = [
        {
            parameter: "Hemoglobin (Hb)",
            result: "13.8",
            unit: "g/dL",
            range: "13.0 - 17.0",
            status: "Normal",
        },
        {
            parameter: "Total WBC Count",
            result: "6,800",
            unit: "/µL",
            range: "4,000 - 11,000",
            status: "Normal",
        },
        {
            parameter: "RBC Count",
            result: "5.12",
            unit: "million/µL",
            range: "4.50 - 5.90",
            status: "Normal",
        },
        {
            parameter: "Hematocrit (PCV)",
            result: "41.6",
            unit: "%",
            range: "40 - 50",
            status: "Normal",
        },
        {
            parameter: "MCV",
            result: "81.3",
            unit: "fL",
            range: "80 - 100",
            status: "Normal",
        },
        {
            parameter: "MCH",
            result: "27.0",
            unit: "pg",
            range: "27 - 32",
            status: "Normal",
        },
        {
            parameter: "MCHC",
            result: "33.2",
            unit: "g/dL",
            range: "32 - 36",
            status: "Normal",
        },
        {
            parameter: "RDW-CV",
            result: "13.1",
            unit: "%",
            range: "11.5 - 14.5",
            status: "Normal",
        },
        {
            parameter: "Platelet Count",
            result: "235000",
            unit: "/µL",
            range: "150000 - 450000",
            status: "Normal",
        },
        {
            parameter: "MPV",
            result: "9.7",
            unit: "fL",
            range: "7.5 - 11.5",
            status: "Normal",
        },
    ];

    return (

        <div className={classes.overlay}>

            <div className={classes.modal}>

                {/* HEADER */}

                <div className={classes.header}>

                    <div className={classes.titleArea}>

                        <div className={classes.iconBox}>
                            <FaFlask />
                        </div>

                        <div>

                            <h2>Lab Test Result</h2>

                            <p>
                                View laboratory test results and details
                            </p>

                        </div>

                    </div>

                    <button
                        className={classes.closeBtn}
                        onClick={onClose}
                    >
                        <FaTimes />
                    </button>

                </div>

                {/* PATIENT CARD */}

                <div className={classes.patientCard}>

                    <div className={classes.patientIcon}>
                        <FaUserFriends />
                    </div>

                    <div className={classes.infoBox}>

                        <small>Patient Name</small>

                        <strong>
                            {test.patient}
                        </strong>

                        <span>
                            {test.patientId}
                        </span>

                    </div>

                    <div className={classes.infoBox}>

                        <small>Age / Gender</small>

                        <strong>
                            34 Y / Male
                        </strong>

                    </div>

                    <div className={classes.infoBox}>

                        <small>Phone</small>

                        <strong>
                            +1 987 654 3210
                        </strong>

                    </div>

                    <div className={classes.infoBox}>

                        <small>Ref. Doctor</small>

                        <strong>
                            Dr. Smith
                        </strong>

                        <span>
                            Hematology
                        </span>

                    </div>

                    <div className={classes.infoBox}>

                        <small>Lab No.</small>

                        <strong>
                            {test.labNo}
                        </strong>

                        <span className={classes.completed}>
                            Completed
                        </span>

                    </div>

                </div>
                {/* TEST DETAILS */}

                <div className={classes.detailsGrid}>

                    <div className={classes.detailItem}>
                        <small>Test</small>
                        <strong>{test.test}</strong>
                    </div>

                    <div className={classes.detailItem}>
                        <small>Department</small>
                        <strong>{test.department}</strong>
                    </div>

                    <div className={classes.detailItem}>
                        <small>Ordered Date</small>
                        <strong>21 May 2024 08:15 AM</strong>
                    </div>

                    <div className={classes.detailItem}>
                        <small>Result Status</small>
                        <span className={classes.normalBadge}>
                            Normal
                        </span>
                    </div>

                    <div className={classes.detailItem}>
                        <small>Sample Type</small>
                        <strong>Whole Blood</strong>
                    </div>

                    <div className={classes.detailItem}>
                        <small>Sample Collected</small>
                        <strong>{test.collected}</strong>
                    </div>

                    <div className={classes.detailItem}>
                        <small>Reported Date</small>
                        <strong>21 May 2024 10:20 AM</strong>
                    </div>

                    <div className={classes.detailItem}>
                        <small>Reviewed By</small>
                        <strong className={classes.blueText}>
                            Dr. James Wilson
                        </strong>
                    </div>

                    <div className={classes.detailItem}>
                        <small>Authorized By</small>
                        <strong className={classes.blueText}>
                            Dr. James Wilson
                        </strong>
                    </div>

                    <div className={classes.detailItem}>
                        <small>Method</small>
                        <strong>Automated Analyzer</strong>
                    </div>

                    <div className={classes.detailItem}>
                        <small>Instrument</small>
                        <strong>Sysmex XN-1000</strong>
                    </div>

                </div>

                {/* TABS */}

                <div className={classes.tabs}>

                    {[
                        "Test Result",
                        "Graph View",
                        "Interpretation",
                        "Comments",
                        "History",
                    ].map((tab) => (

                        <button
                            key={tab}
                            onClick={() => setActiveTab(tab)}
                            className={
                                activeTab === tab
                                    ? classes.activeTab
                                    : classes.tab
                            }
                        >
                            {tab}
                        </button>

                    ))}

                </div>

                {/* RESULT TABLE */}

                {activeTab === "Test Result" && (

                    <>

                        <h3 className={classes.sectionTitle}>
                            Hematology
                        </h3>

                        <table className={classes.table}>

                            <thead>

                                <tr>

                                    <th>Test Parameter</th>
                                    <th>Result</th>
                                    <th>Unit</th>
                                    <th>Reference Range</th>
                                    <th>Status</th>

                                </tr>

                            </thead>

                            <tbody>

                                {resultData.map((item, index) => (

                                    <tr key={index}>

                                        <td>{item.parameter}</td>

                                        <td>{item.result}</td>

                                        <td>{item.unit}</td>

                                        <td>{item.range}</td>

                                        <td>

                                            <span className={classes.normalBadge}>
                                                {item.status}
                                            </span>

                                        </td>

                                    </tr>

                                ))}

                            </tbody>

                        </table>

                        <div className={classes.noteBox}>

                            <strong>Note:</strong>

                            Results are validated electronically and are as per
                            the reference range of the laboratory.

                        </div>

                    </>

                )}

                {activeTab === "Graph View" && (

                    <div className={classes.graphContainer}>

                        <div className={classes.graphHeader}>

                            <div>

                                <h3>Hemoglobin (Hb)</h3>

                                <p>
                                    Reference Range: 13.0 - 17.0 g/dL
                                </p>

                            </div>

                            <div className={classes.graphActions}>

                                <select className={classes.select}>

                                    <option>Last 6 Results</option>
                                    <option>Last 12 Results</option>
                                    <option>Last 24 Results</option>

                                </select>

                                <button className={classes.graphBtn}>
                                    Export Graph
                                </button>

                            </div>

                        </div>

                        <div className={classes.chartCard}>

                            <ResponsiveContainer
                                width="100%"
                                height={350}
                            >

                                <LineChart data={graphData}>

                                    <CartesianGrid strokeDasharray="3 3" />

                                    <XAxis dataKey="date" />

                                    <YAxis />

                                    <Tooltip />

                                    <ReferenceLine
                                        y={17}
                                        stroke="#16A34A"
                                        strokeDasharray="5 5"
                                    />

                                    <ReferenceLine
                                        y={13}
                                        stroke="#EF4444"
                                        strokeDasharray="5 5"
                                    />

                                    <Line
                                        type="monotone"
                                        dataKey="value"
                                        stroke="#2563EB"
                                        strokeWidth={3}
                                    />

                                </LineChart>

                            </ResponsiveContainer>

                        </div>

                        <div className={classes.historyContainer}>

                            <h3>Previous Results</h3>

                            <table className={classes.table}>

                                <thead>

                                    <tr>

                                        <th>Date</th>
                                        <th>Result</th>
                                        <th>Reference Range</th>

                                    </tr>

                                </thead>

                                <tbody>

                                    {graphData.map((item, index) => (

                                        <tr key={index}>

                                            <td>{item.date}</td>

                                            <td>{item.value}</td>

                                            <td>13.0 - 17.0</td>

                                        </tr>

                                    ))}

                                </tbody>

                            </table>

                        </div>

                    </div>

                )}
                {activeTab === "Interpretation" && (
                    <div className={classes.interpretationContainer}>
                        <h3>Interpretation</h3>

                        <div className={classes.interpretationCard}>
                            <strong>Overall Result</strong>
                            <span className={classes.normalBadge}>Normal</span>

                            <p>
                                Complete Blood Count (CBC) results are within the normal
                                reference range. No significant abnormalities were detected.
                            </p>

                            <ul>
                                <li>Hemoglobin is within normal range.</li>
                                <li>White blood cell count is normal.</li>
                                <li>Platelet count is normal.</li>
                                <li>No evidence of anemia or infection.</li>
                            </ul>
                        </div>
                    </div>
                )}

                {activeTab === "Comments" && (
                    <div className={classes.commentsContainer}>
                        <h3>Laboratory Comments</h3>

                        <textarea
                            rows={6}
                            placeholder="Enter laboratory comments..."
                        />

                        <button className={classes.saveCommentBtn}>
                            Save Comment
                        </button>
                    </div>
                )}

                {activeTab === "History" && (
                    <div className={classes.historyContainer}>

                        <h3>Previous Laboratory Results</h3>

                        <table className={classes.table}>

                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Test</th>
                                    <th>Status</th>
                                    <th>Doctor</th>
                                </tr>
                            </thead>

                            <tbody>

                                <tr>
                                    <td>21 May 2024</td>
                                    <td>Complete Blood Count</td>
                                    <td>
                                        <span className={classes.normalBadge}>
                                            Completed
                                        </span>
                                    </td>
                                    <td>Dr. Smith</td>
                                </tr>

                                <tr>
                                    <td>05 May 2024</td>
                                    <td>Complete Blood Count</td>
                                    <td>
                                        <span className={classes.normalBadge}>
                                            Completed
                                        </span>
                                    </td>
                                    <td>Dr. James Wilson</td>
                                </tr>

                            </tbody>

                        </table>

                    </div>
                )}

                {/* FOOTER */}

                <div className={classes.footer}>

                    <div className={classes.leftButtons}>
                        <button
                            className={classes.outlineBtn}
                            onClick={handlePrint}
                        >

                            <FaPrint />

                            Print Result

                        </button>

                        <button
                            className={classes.outlineBtn}
                            onClick={handleDownload}
                        >

                            <FaDownload />

                            Download (PDF)

                        </button>

                    </div>

                    <div className={classes.rightButtons}>

                        <button
                            className={classes.closeButton}
                            onClick={onClose}
                        >
                            Close
                        </button>

                        <button className={classes.sendBtn}>

                            <FaPaperPlane />

                            Send to Doctor

                        </button>

                    </div>

                </div>

            </div>

        </div>

    );

}

export default LabResult;